import { BackendPagination } from "../pagination.model";
import { EndpointRequest } from "./endpoints.model";

export interface SentEmailsRequest extends EndpointRequest {
	config: {
		params: BackendPagination;
	};
}

export interface SentEmailsCountRequest extends EndpointRequest {
	config: {
		params: {
			search: string | null;
			filters: string | null;
		};
	};
}

export enum SentMessageSource {
	EMAIL = "EMAIL",
	FAX = "FAX",
	EPIC = "EPIC",
}

export const SENT_MESSAGE_SOURCE_TO_CHANNEL: Record<SentMessageSource, string> = {
	[SentMessageSource.EMAIL]: "PAUBOX",
	[SentMessageSource.FAX]: "FAX",
	[SentMessageSource.EPIC]: "EPIC",
};

export const HEALTH_NETWORK_ID = "HEALTH_NETWORK";

export interface CreateSentMessageRequest extends EndpointRequest {
	body: {
		participantId: number;
		kannactId: string;
		timestamp: string;
		from: string;
		source?: SentMessageSource | null;
		channel: string;
		to: string;
		status: string;
		origin: string;
		subject: string;
	};
}
